































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { externalUserWebservice } from '@/webservices/externalUser';
import type { Project } from '@/models/project';
import type { ExternalUser } from '@/models/externalUser';
import AddExternalUser from './AddExternalUser.vue';
import ManageExternalUsers from './ManageExternalUsers.vue';
import { FormState } from '@/components/prine/enums/FormState';
import { hasAnyPermission, hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'SelectExternalUsers',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasAnyPermission, hasPermission },
    components: {
        AddExternalUser,
        ManageExternalUsers,
    },
})
export default class SelectExternalUsers extends Vue {
    public FormState = FormState;

    @Prop({
        type: Number,
        default: () => FormState.New,
    })
    private state: FormState;

    @Prop() private project: Project;
    @Prop() private isDesktop: boolean;
    @Prop() private projectExternalUsers: ExternalUser;
    @Prop({ default: false }) private disabled: boolean;

    private selectedExternalUsersData: ExternalUser[] = [] as ExternalUser[];
    private externalUsers: ExternalUser[] = [] as ExternalUser[];

    public reload() {
        this.loadExternalUsers();
        this.$emit('reload');
    }

    // Mounted is called initially
    private mounted() {
        this.loadExternalUsers();
        this.selectedExternalUsersData = JSON.parse(JSON.stringify(this.projectExternalUsers));
        this.$watch(
            () => this.projectExternalUsers,
            () => {
                this.selectedExternalUsersData = JSON.parse(JSON.stringify(this.projectExternalUsers));
            }
        );
    }

    private loadExternalUsers() {
        externalUserWebservice
            .getAll(this.project.id)
            .then((res) => {
                this.externalUsers = res.data;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    private fullname({ firstname, lastname, tenant }) {
        if (tenant !== '' && firstname !== '' && lastname !== '') {
            return `${firstname} ${lastname}` + (tenant ? ` (${tenant})` : '');
        }

        if (tenant === '' && firstname !== '' && lastname !== '') {
            return `${firstname} ${lastname}`;
        }

        return `${tenant}`;
    }
}
